'use client';

import { useState, useEffect, useCallback } from 'react';
import {
  APP_STORE_URL,
  PLAY_STORE_URL,
  BANNER_DISMISSED_KEY
} from './promotionalBanner.constants';

function getAppStoreUrl(): string {
  if (typeof window === 'undefined') return APP_STORE_URL;

  if (!PLAY_STORE_URL) return APP_STORE_URL;

  const userAgent = window.navigator.userAgent.toLowerCase();
  const isAndroid = /android/.test(userAgent);

  return isAndroid ? PLAY_STORE_URL : APP_STORE_URL;
}

export function usePromotionalBanner() {
  const [isDismissed, setIsDismissed] = useState(true);

  useEffect(() => {
    const dismissed = sessionStorage.getItem(BANNER_DISMISSED_KEY);
    setIsDismissed(dismissed === 'true');
  }, []);

  const handleDismiss = useCallback(() => {
    setIsDismissed(true);
    sessionStorage.setItem(BANNER_DISMISSED_KEY, 'true');
  }, []);

  const handleDownload = useCallback(() => {
    const url = getAppStoreUrl();
    window.open(url, '_blank', 'noopener,noreferrer');
  }, []);

  return {
    isDismissed,
    handleDismiss,
    handleDownload
  };
}
